export const GET_CLIENT_INVOICES = 'GET_CLIENT_INVOICES';
export const SET_CLIENT_AVAILABLE_DAYS = 'SET_CLIENT_AVAILABLE_DAYS';
export const GET_TAX_TOTAL = 'GET_TAX_TOTAL';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const SET_SEARCH_REPORT_GENERAL = 'SET_SEARCH_REPORT_GENERAL';
